const STORAGE_KEY = "crmHiddenLeadIds";

export function isCrmSubscriptionPackage(pkg) {
  const normalized = String(pkg || "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
  return normalized === "crm" || normalized.includes("crm");
}

export function getCrmHiddenLeadIds() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = JSON.parse(raw || "[]");
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
}

export function hideLeadInCrm(leadId) {
  const id = String(leadId);
  const ids = getCrmHiddenLeadIds();
  if (!ids.includes(id)) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids, id]));
  }
}

export function hideLeadsInCrm(leadIds) {
  const existing = new Set(getCrmHiddenLeadIds());
  (leadIds || []).forEach((leadId) => {
    if (leadId != null && leadId !== "") existing.add(String(leadId));
  });
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...existing]));
}

export function filterLeadsHiddenInCrm(leads, isCrmPackage) {
  if (!isCrmPackage || !Array.isArray(leads)) return leads || [];
  const hidden = new Set(getCrmHiddenLeadIds());
  return leads.filter((lead) => !hidden.has(String(lead?.id ?? "")));
}
